import React from 'react';
import FanLightDetailsListItem from './fan-light-details-list-item'

let FanLightDetailsList = (props) =>
    <ul className="fan-light-details-list">
        <FanLightDetailsListItem {...props}/>
    </ul>


export default FanLightDetailsList;